/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Program.ScoreCard.vue?vue&type=template&id=054c29f5&scoped=true"
import script from "./Program.ScoreCard.vue?vue&type=script&lang=js"
export * from "./Program.ScoreCard.vue?vue&type=script&lang=js"
import style0 from "./Program.ScoreCard.vue?vue&type=style&index=0&id=054c29f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054c29f5",
  null
  
)

export default component.exports